
// Location redirect code start

if (typeof IPRedirect === 'undefined') {
  // redirect.js failed to initialise (jQuery not available) — skip legacy redirect
} else {
  // Settings come from Theme settings → Location Redirect, output by snippets/scripts.liquid (#ip-redirect-settings)
  var ipRedirectSettings = document.getElementById('ip-redirect-settings');
  if (ipRedirectSettings) {
    try {
      IPRedirect.init(JSON.parse(ipRedirectSettings.textContent));
      IPRedirect.run();
    } catch (e) {
      console.error('Location redirect skipped:', e);
    }
  }
}

// Location redirect code end